

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoConfirmUpopRoute', {
    path: 'confirmUpop',
    directive: _directive2['default'],
    titleContent: 'confirmUpop.confirm',
    trackingData: {
        fptiState: 'confirm_upop'
    },
    query: ['fromLoginOverlay'],
    loginRequired: true,
    pageOnOverlay: true,
    children: []
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/confirm-upop/route.js
// module id = ./components/xo-wallet-components/src/confirm-upop/route.js
// module chunks = 1